export default "__VITE_ASSET__FOmikzR8__"